module.exports = __webpack_public_path__ + "img/ft_1.bf7df107.jpg";